import { StyleSheet } from 'react-native';
import Theme from 'Theme';

import { Device } from 'DeviceUtils';

const sharedStyles = {
    programTitle: {
        fontFamily: Theme.regularFont,
        fontSize: 24,
        color: Theme.primaryTextColor,
        marginTop: 21
    },
    programSubtitle: {
        fontFamily: Theme.regularFont,
        fontSize: 18,
        color: Theme.secondaryTextColor,
        marginBottom: 19
    },
    programSubtitleNoMargin: {
        marginBottom: 5
    },
    icon: {
        width: 60,
        height: 27,
        marginLeft: 25,
        marginRight: 25,
        resizeMode: 'contain'
    },
    lockIcon: {
        width: 27,
        height: 27,
        marginLeft: 41,
        marginRight: 41,
        resizeMode: 'contain'
    },
    iptvOnly: {
        flexDirection: 'row'
    },
    iptvOnlyText: {
        fontFamily: Theme.regularFont,
        fontSize: 18,
        color: Theme.primaryTextColor,
        marginBottom: 19
    },
    iptvInfoIcon: {
        width: 20,
        height: 20,
        marginRight: Theme.BU / 2
    },
    textArea: {
        flex: 1,
        flexDirection: 'row',
        borderBottomColor: Theme.secondaryTextColor,
        borderBottomWidth: 1
    },
    firstTextArea: {
        borderTopColor: Theme.secondaryTextColor,
        borderTopWidth: 1
    },
    metadata: {
        justifyContent: 'center',
        flex: 1
    },
    checkbox: {
        width: 31,
        height: 31,
        marginHorizontal: Theme.BU,
        alignSelf: 'center'
    },
    hiddenIconStyle: {
        width: 0,
        marginLeft: 0,
        marginRight: 25
    }
};

if (Device.isTabletOrWeb) {
    sharedStyles.metadata = {
        ...sharedStyles.metadata,
        flexDirection: 'row',
        justifyContent: 'space-between'
    };
    sharedStyles.programTitle.marginVertical = sharedStyles.programTitle.marginTop;
    delete sharedStyles.programTitle.marginTop;
    delete sharedStyles.programSubtitle.marginBottom;
    sharedStyles.programSubtitle.alignSelf = 'center';
    sharedStyles.textArea.marginRight = Theme.BU;
}

const baseStyles = {
    ...sharedStyles,
    container: {
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'row'
    },
    row: {}
};

export default StyleSheet.create(baseStyles);
export { sharedStyles };
